import React from "react";
import img1 from "../pages/image1/jin3.jpg";
import img2 from "../pages/image1/jin5.jpg";
import img3 from "../pages/image1/jin4.jpg";
import Swipernew from "./Swipernew";
import './destination.css'
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Typography from '@mui/material/Typography';
import SimpleImageSlider from "react-simple-image-slider";
import slide_image_1 from '../pages/image1/kampala.jpg';
import slide_image_2 from '../pages/image1/kampala1.jpg';
import slide_image_3 from '../pages/image1/kampala2.jpg';
import slide_image_4 from '../pages/image1/kampala4.jpg';

export default function Destination8() {


 
  const imageArray = [
    slide_image_1,
    slide_image_2,
    slide_image_3,
    slide_image_4,
  
  ];
  return (
    <>
      <div>
      <div>
            <Swipernew images={imageArray} />
        </div>
        <div className="m-2 pt-5">
          <div className="container-fluid">
          <div className="ms-auto me-auto  bg2">

<h1 className="text-center name11  ">
Full Day Kampala City Tour
</h1>
</div>
           

            <h2>Description:</h2>
            <h3 className="ms-5 pt-3">
              &emsp;&emsp;This one-day City Tour offers you an opportunity to experience
              our city. You will get to visit the unique historical landmark buildings
              within Kampala City.
            </h3>
          </div>
        </div>

        <div className="container-fluid">
          <Box sx={{ padding: 2 }}>
            <Stepper orientation="vertical" activeStep={8}>
              {steps.map((step, index) => (
                <Step key={step.label1} color="black">
                  {/* Pass label1 to StepLabel */}

                  <StepLabel><h3> {step.label1}</h3></StepLabel>
                  <div className=" bordernew  ">
                    {/* Add the secondary label (optional, shown below the main one) */}
                    <Typography variant="subtitle1" color="textblack" sx={{ ml: 2 }}>
                      <h4><b>{step.label}</b></h4>
                    </Typography>
                    {/* Directly display the description */}
                    <Typography sx={{ mt: 1, mb: 2, ml: 2 }}><h4>&emsp;{step.description}</h4></Typography></div>
                </Step>
              ))}
            </Stepper>
          </Box>
          <h2>Note:</h2>
          <h3 className="ms-5 pt-3">
            &emsp;  &emsp;This tour includes transportation by car, a guide, lunch and entry fee where applicable.

          </h3>



        </div>
        <div class="btn-box text-white text-center">
          <a href="https://wa.me/+971551579904" class="theme-btn btn-style-one rounded-3 m-4 ">Book Now</a>
        </div></div>


    </>
  );
}
const steps = [
  {
    // label1: 'Day - 1',
    // label: 'Arrival and transfer to your hotel',

    description: `Kings Parliament in Mengo.
`,
  },
  {
    // label1: 'Day - 2',
    // label: 'Drive to Kibale National Park via Fort Portal (Highlights-Chimpanzee)',

    description: `  The historical religious places of worship like Namirembe and Rubaga Cathedrals.`

  },
  {
    // label1: 'Day - 3',
    // label: ' Chimpanzee tracking ( Kibale NP) and Bigodi Swamp Walk and transfer to Queen Elizabeth National Park',
    description: `  Independence Monument`
  },
  {
    // label1: 'Day - 4',
    // label: 'Game drive and afternoon boat cruise at Kazinga Channel',
    description: `The Uganda Parliament Building`
  },
  {
    // label1: 'Day - 5',
    // label: 'Tree-climbing lions in Ishasha and transfer to Bwindi National Park',
    description: `Uganda National Museum `
  },
  {
    // label1: 'Day - 6',
    // label: 'Gorilla Tracking in Bwindi Impenetrable Forest - Transfer to Mbarara',
    description: ` Crafts Market at the National Theatre.`
  },
  {
    // label1: 'Day - 7',
    // label: 'This marks the end of your 7-day tour in Uganda.',
    description: `The Uganda National Mosque `
  },
  {
    // label1: 'Day - 8',
    // label: 'This marks the end of your 7-day tour in Uganda.',
    description: `Nakasero Market `
  },
];
